import React from 'react';

import { PartnerRegistrationManagerLayoutComponent } from 'design/partnerRegistrationManagerLayout';
import { ThemeProviderComponent } from 'design/themeProvider';
import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { SpinnerExtraLarge } from 'design/spinnerExtraLarge/spinnerExtraLargeComponents';

export const PartnerRegistrationManagerAsyncFallback = () => {
  return (
    <ThemeProviderComponent mode="onDark">
      <PartnerRegistrationManagerLayoutComponent
        content={
          <CenteredLayoutComponent noOverlay>
            <SpinnerExtraLarge />
          </CenteredLayoutComponent>
        }
      />
    </ThemeProviderComponent>
  );
};
